import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Country } from './contact-sales.component';

export class SalesFormResponse {
  cmnowreasons: string[] | undefined;
  aointerests: string[] | undefined;
  industries: string[] | undefined;
  geo: Country[] | undefined;
}

export interface GoogleReCaptchaValidateResponse {
  success: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ContactSalesService {
  private readonly _salesFormURI: string = 'api/v1/contact-sales';
  private readonly _reCaptchaApiURL: string = 'api/pdx/v1/recaptcha';

  constructor(private _httpClient: HttpClient) {}

  public getSalesFormValues(): Observable<SalesFormResponse> {
    return this._httpClient.get<SalesFormResponse>(this._salesFormURI);
  }

  public verifyGoogleReCaptcha(reCaptchaToken: string): Observable<GoogleReCaptchaValidateResponse> {
    return this._httpClient.post<GoogleReCaptchaValidateResponse>(this._reCaptchaApiURL, { reCaptchaToken });
  }
}
